import { useCallback, useRef } from 'react';
import type { FormEventCallbacks, FormEventDispatch } from './types';

export function useFormEventDispatch(
  callbacks: FormEventCallbacks
): FormEventDispatch {
  const callbacksRef = useRef(callbacks);
  // eslint-disable-next-line react-hooks/refs
  callbacksRef.current = callbacks;

  return useCallback((eventName, instance) => {
    const cbs = callbacksRef.current;
    cbs.onFormEvent?.(eventName, instance);
    if (eventName === 'onFormReady') {
      if (instance) {
        cbs.onFormReady?.(instance);
      }
    } else {
      cbs[eventName]?.();
    }
  }, []);
}
